import { globalPostService } from "../../globalServices";
import { checkApiStatus } from "../utils_v2";
import config from "../../config";
import { setGlobalCookie} from "../../utils";
import { browserHistory } from "react-router";
const enableAssetListing = (lessorId,token,setLoading, reloadNeeded) => {
    setLoading(true)
    globalPostService('api/user-authorization/', {lessor_id: lessorId,accessToken:token, lite:true, permissions:['console', 'contracts', 'is_records', 'is_technical', 'is_maintenance', 'is_camo', 'is_lease_revamp', 'is_mr_calculator', 'is_valuation', 'is_contracts']})
        .then(response => {
            setLoading(false)
            if (checkApiStatus(response)) {
                let userDetail = response.data.data;
                userDetail = {
                    ...userDetail,
                    access: response.data.data.lessor_access_token,
                    defaultLessor: response.data.data.current_lessor,
                    user: response.data.data.user
                }
                let baseDomain = '.sparta.aero', expireAfter = new Date();
                localStorage.setItem('userInfo', JSON.stringify(userDetail));
                let cookieData = JSON.stringify({ access: response.data.data.lessor_access_token, id: response.data.data.current_lessor.id,refresh: '', environment: config.env.key, user: {id : userDetail?.user?.id, name: userDetail?.user?.name, out_of_office: userDetail?.user?.out_of_office} });
                let cookieName = JSON.stringify({ name: response.data.data.user.name, designation: response.data.data.user.designation });
                let hasMultilLessorAccess = response.data.data.has_multi_lessor ? response.data.data.has_multi_lessor : 'false'
                setGlobalCookie('userName', cookieName, 3);
                setGlobalCookie("lessorAccess", cookieData, 3);
                setGlobalCookie("domain", baseDomain, 3);
                setGlobalCookie("hasMultilLessorAccess", hasMultilLessorAccess, 3);
                let currentLocation = browserHistory.getCurrentLocation();
                if(currentLocation?.query?.apps && config.domain[currentLocation?.query?.apps]){
                    let appUrl = config.domain[currentLocation?.query?.apps];
                    window.open(appUrl,'_self')
                    if(reloadNeeded==='true'){
                        window.location.reload()
                    }
                }else{
                    browserHistory.push('/');
                    window.location.reload()
                }
            }
        });
}

export default enableAssetListing;